import { c as _c } from "react/compiler-runtime";
import { FormProvider, useForm } from 'react-hook-form';
import Form from '../../../../../form';
import Text from '../../../../../text';
import type { FilterMultiSelectGrouped, FilterSelectedOption } from '../../../../filters.types';
type FormData = {
  filter: FilterSelectedOption[];
};
export type MultiSelectFormProps = {
  onSubmit: (nextSelectedOptions: string[]) => void;
  options: FilterMultiSelectGrouped['options'];
  selectedOptions: FilterMultiSelectGrouped['selectedOptions'];
};
const MultiSelectGroupedForm = t0 => {
  const $ = _c(15);
  const {
    onSubmit,
    options,
    selectedOptions
  } = t0;
  let t1;
  if ($[0] !== selectedOptions) {
    t1 = {
      defaultValues: {
        filter: selectedOptions
      }
    };
    $[0] = selectedOptions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const methods = useForm(t1);
  const {
    handleSubmit
  } = methods;
  let t2;
  if ($[2] !== onSubmit) {
    t2 = formData => {
      onSubmit(formData.filter);
    };
    $[2] = onSubmit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleAfterSubmit = t2;
  let t3;
  if ($[4] !== handleAfterSubmit || $[5] !== handleSubmit) {
    t3 = handleSubmit(handleAfterSubmit);
    $[4] = handleAfterSubmit;
    $[5] = handleSubmit;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== options) {
    t4 = options.map(_temp2);
    $[7] = options;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <form className="grid gap-6" id="filter-form" onSubmit={t3}>{t4}</form>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== methods || $[13] !== t5) {
    t6 = <FormProvider {...methods}>{t5}</FormProvider>;
    $[12] = methods;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default MultiSelectGroupedForm;
function _temp(option) {
  return {
    label: option.label,
    value: option.value
  };
}
function _temp2(group) {
  return <fieldset className="grid gap-2" key={group.label}><Text variant="label-2" marginBottom={3}>{group.label}</Text><Form.CheckboxGroup name="filter" options={group.options.map(_temp)} className="flex flex-col gap-2" /></fieldset>;
}